import Vue from 'vue'
import Vuex from 'vuex'
import { search } from './modules/search'
import { user } from './modules/user'
import { firm } from './modules/firm'
import { presentations } from './modules/presentations'
import { loader } from './modules/loader'
import { claim } from './modules/claim'
import { order } from './modules/order'
import { step } from './modules/step'
import { gopay } from './modules/gopay'
import { config } from './modules/config'
Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        search,
        user,
        firm,
        presentations,
        loader,
        claim,
        order,
        step,
        gopay,
        config,
    },
})
